import { render, staticRenderFns } from "./block-admin-templates.vue?vue&type=template&id=93721484&scoped=true&lang=pug"
import script from "./block-admin-templates.vue?vue&type=script&lang=js"
export * from "./block-admin-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93721484",
  null
  
)

export default component.exports